class MobileAccordion extends HTMLElement {
  constructor() {
    super();
    this.tabs = this.querySelectorAll(".footer-item-mobile");
    this.buttons = this.querySelectorAll(".accordion-button");
  }

  connectedCallback() {
    this.buttons.forEach((btn, i) => {
      btn.addEventListener("click", () => this.onClick(i));
    });

    this.onMatchMedia();
  }

  onClick(index) {
    this.tabs[index]?.classList.contains("active")
      ? this.closeTab(index)
      : this.openTab(index);
  }

  openTab(index) {
    this.tabs[index].classList.add("active");
    this.tabs[index].style.maxHeight = `${this.tabs[index].scrollHeight}px`;
  }

  closeTab(index) {
    this.tabs[index].classList.remove("active");
    this.tabs[index].style.maxHeight = "20px";
  }

  onMatchMedia() {
    this.mql = window.matchMedia("(max-width: 991.98px)");
    this.mql.onchange = (e) => {
      if (!e.matches) {
        window.removeEventListener("resize", this.onResize.bind(this));
      } else {
        window.addEventListener("resize", this.onResize.bind(this));
      }
    };
  }

  onResize() {
    this.querySelectorAll(".footer-item-mobile.active").forEach((item) => {
      item.style.maxHeight = `${item.scrollHeight}px`;
    });
  }
}

if (!window.customElements.get("mobile-accordion")) {
  window.customElements.define("mobile-accordion", MobileAccordion);
}
